import { useSession } from "next-auth/client";
import { repository } from "repositories";
import { useSwrConfig } from "shared/lib/swr/config";
import { GetSubscriptionListRes, SWRResponse } from "shared/types";
import useSWR, { SWRConfiguration } from "swr";

export const useSubscriptionList = (
  config?: SWRConfiguration
): SWRResponse<GetSubscriptionListRes> => {
  const [session] = useSession();
  const repo = repository.subscription.getList();

  const defaultConfig = useSwrConfig();
  const { data, error, mutate } = useSWR(
    session ? repo.path : null,
    repo.fetcher,
    {
      ...defaultConfig,
      fallbackData: repo.fallbackData,
      ...config,
    }
  );

  return {
    ...data,
    isLoading: !data && !error,
    isError: !!error,
    mutate,
  };
};
